import React from 'react';

const Loader = () => {
  return (
    <div>
      <span className='loader'></span>
      <h4 className='text-[#134463] font-bold font-mono'>Loading...</h4>
    </div>
  );
};

export default Loader;
